<div class="flex flex-col gap-4 w-full">

  <p-card>
    <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex items-center gap-3">
        <!-- currentColor: escuro no tema claro, claro no tema escuro -->
        <svg viewBox="0 0 48 48" fill="none" class="w-10 h-10 text-gray-800 dark:text-gray-100" aria-hidden="true">
          <line x1="24" y1="5" x2="24" y2="11" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          <circle cx="24" cy="5" r="3" fill="#E41B2E"/>
          <rect x="9" y="11" width="30" height="24" rx="7" stroke="currentColor" stroke-width="2.5"/>
          <circle cx="18" cy="22" r="3.5" fill="#E41B2E"/>
          <circle cx="30" cy="22" r="3.5" fill="#E41B2E"/>
          <path d="M18 29.5h12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          <path d="M9 21H5v7h4M39 21h4v7h-4" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round"/>
          <path d="M16 35v6M32 35v6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
        <div>
          <div class="header-title-table">Bot SisNot ↔ SEI</div>
          <div class="text-sm text-gray-500 dark:text-gray-400">
            Confere no SEI se os processos das notificações estão na caixa da unidade e, no fim, quais processos da caixa não têm notificação no SisNot.
            Pode ir para outras telas: o bot continua pesquisando.
          </div>
        </div>
      </div>
      @if (sei.estado() !== 'logado') {
        <div class="text-sm font-semibold text-amber-700 dark:text-amber-400">
          <i class="pi pi-exclamation-circle mr-1"></i>Entre no SEI (botão do SEI no topo) para o bot pesquisar.
        </div>
      }
    </div>
  </p-card>

  @if (bot.carregando()) {
    <p-card><span class="text-sm">Carregando os processos do SisNot…</span></p-card>
  } @else if (bot.erroCarga()) {
    <p-card><span class="text-sm text-red-700 dark:text-red-400">{{ bot.erroCarga() }}</span></p-card>
  } @else {
    <!-- O que conferir -->
    <p-card>
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        <div class="flex flex-col gap-1">
          <label for="caixa" class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">Caixas do SEI (unidades exatas)</label>
          <input id="caixa" pInputText [(ngModel)]="novaCaixa" list="unidadesVistas" class="uppercase"
                 [placeholder]="caixas().length ? 'Outra caixa… (Enter)' : 'Ex.: ARTESP-SUROD-SUP (Enter)'"
                 (keydown.enter)="adicionarCaixa($event)" (keydown.,)="adicionarCaixa($event)" (blur)="adicionarCaixa()"/>
          <datalist id="unidadesVistas">
            @for (u of bot.unidadesVistas(); track u) { <option [value]="u"></option> }
          </datalist>
          @if (caixas().length) {
            <div class="flex flex-wrap gap-1">
              @for (c of caixas(); track c) {
                <p-chip [label]="c" [removable]="!bot.rodando()" (onRemove)="removerCaixa(c)" styleClass="!text-xs !py-0.5"/>
              }
            </div>
          }
          <span class="text-xs text-gray-500 dark:text-gray-400">
            Pode pôr mais de uma: digite e aperte Enter. Só conta a unidade exata: subunidade é outra caixa no SEI
            (ex.: SUROD-GERER-COGEP-NOT não é ARTESP-SUROD).
          </span>
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">Status no SisNot</label>
          <p-multiselect [options]="opcoes().status" [ngModel]="status()" (ngModelChange)="status.set($event)"
                         placeholder="Todos" [filter]="false" display="chip" styleClass="w-full"/>
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">Superintendência</label>
          <p-multiselect [options]="opcoes().superintendencias" [ngModel]="superintendencias()" (ngModelChange)="superintendencias.set($event)"
                         placeholder="Todas" [filter]="false" display="chip" styleClass="w-full"/>
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">Concessionária</label>
          <p-multiselect [options]="opcoes().concessionarias" [ngModel]="concessionarias()" (ngModelChange)="concessionarias.set($event)"
                         placeholder="Todas" display="chip" styleClass="w-full"/>
        </div>
      </div>

      @if (podeEditar) {
        <!-- o que o Conferir faz: só consulta ou também grava a Localização -->
        <div class="flex flex-wrap items-center gap-2 mt-4">
          <p-selectbutton [options]="opcoesModo" [ngModel]="bot.estado().atualizarLocalizacao"
                          (ngModelChange)="bot.definirAtualizarLocalizacao(!!$event)" [allowEmpty]="false"
                          optionLabel="label" optionValue="value" size="small"/>
          <span class="text-xs text-gray-500 dark:text-gray-400">
            @if (bot.estado().atualizarLocalizacao) {
              Grava na Localização a(s) unidade(s) do SEI (todas, separadas por vírgula; sobrestado: a unidade do sobrestamento).
              Concluído, anexado ou não encontrado não muda. Cada mudança vai pro Histórico da notificação.
            } @else {
              Só pesquisa e mostra o resultado: nada é gravado no SisNot.
            }
          </span>
        </div>
      }
      <div class="flex flex-wrap items-center gap-2 mt-4">
        <p-button [label]="(bot.estado().atualizarLocalizacao && podeEditar ? 'Conferir e atualizar ' : 'Conferir ') + numerosSelecionados().length + ' processo(s) no SEI'" icon="pi pi-play" styleClass="btn-red"
                  [disabled]="bot.rodando() || !numerosSelecionados().length" (onClick)="iniciar()"/>
        @if (bot.rodando()) {
          <p-button label="Pausar" icon="pi pi-pause" severity="secondary" [outlined]="true" (onClick)="bot.pausar()"/>
        } @else if (bot.pendente()) {
          <p-button label="Continuar de onde parou" icon="pi pi-step-forward" severity="secondary" [outlined]="true" (onClick)="bot.continuar()"/>
        }
        @if (bot.progresso().total && !bot.rodando() && !bot.lendoCaixa()) {
          <p-button label="Trocar só as caixas" icon="pi pi-sync" severity="secondary" [text]="true" (onClick)="aplicarCaixas()"
                    pTooltip="Refaz o relatório para as caixas da lista sem pesquisar os processos de novo (e lê no SEI as caixas novas)"/>
        }
      </div>
      <!-- as duas etapas do Conferir -->
      <ol class="text-xs text-gray-500 dark:text-gray-400 mt-3 space-y-0.5 list-decimal pl-4">
        <li [class.font-bold]="bot.rodando()" [class.text-gray-800]="bot.rodando()" [class.dark:text-white]="bot.rodando()">
          Onde está cada processo: pesquisa no SEI os {{ numerosSelecionados().length }} processo(s) das notificações dos filtros, um por vez, com a sua sessão do SEI.
          Os que estão em vermelho na sua unidade não são abertos (o vermelho continua).
          @if (bot.progresso().total && !bot.pendente()) { <i class="pi pi-check text-green-600 ml-1"></i> }
        </li>
        <li [class.font-bold]="bot.lendoCaixa()" [class.text-gray-800]="bot.lendoCaixa()" [class.dark:text-white]="bot.lendoCaixa()">
          No fim, lê cada caixa no SEI e mostra os processos que estão nelas e não têm notificação no SisNot ("Só no SEI").
          A leitura troca de unidade no SEI por baixo dos panos e volta para a sua no fim.
          @if (bot.caixasLidasTodas()) { <i class="pi pi-check text-green-600 ml-1"></i> }
        </li>
      </ol>
      @if (bot.lendoCaixa() && sei.andamento()) {
        <div class="text-xs mt-1"><i class="pi pi-spin pi-spinner mr-1"></i>{{ sei.andamento() }}</div>
      }
      @if (bot.erroCaixa()) {
        <div class="text-xs mt-1 text-red-700 dark:text-red-400"><i class="pi pi-exclamation-circle mr-1"></i>{{ bot.erroCaixa() }}</div>
      }
    </p-card>

    @if (bot.progresso().total || bot.algumaCaixaLida()) {
      @if (bot.progresso().total) {
        <!-- Andamento -->
        <p-card>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
            <div><div class="text-xs text-gray-500 dark:text-gray-400">Conferidos</div>
              <div class="font-bold text-lg">{{ bot.progresso().feitos }} de {{ bot.progresso().total }} ({{ bot.progresso().pct }}%)</div></div>
            <div><div class="text-xs text-gray-500 dark:text-gray-400">Tempo decorrido</div><div class="font-bold text-lg">{{ bot.progresso().decorrido }}</div></div>
            <div><div class="text-xs text-gray-500 dark:text-gray-400">Média por processo</div><div class="font-bold text-lg">{{ bot.progresso().media }}</div></div>
            <div><div class="text-xs text-gray-500 dark:text-gray-400">Falta (estimativa)</div><div class="font-bold text-lg">{{ bot.progresso().falta }}</div></div>
          </div>
          <div class="h-1.5 rounded bg-gray-200 dark:bg-zinc-800 overflow-hidden mt-3">
            <div class="h-full bg-[#E41B2E] transition-all" [style.width.%]="bot.progresso().pct"></div>
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400 mt-2">
            @if (bot.protegendo()) { {{ sei.andamento() }} }
            @else if (bot.rodando()) { Pesquisando {{ bot.atual() }} no SEI… } @else if (bot.pendente()) { Pausado. }
            @if (bot.lendoCaixa()) { Etapa 2: lendo a caixa {{ bot.lendoCaixa() }} no SEI… {{ sei.andamento() }} }
            {{ bot.estado().caixas.length > 1 ? 'Caixas' : 'Caixa' }}: <b>{{ bot.estado().caixas.join(', ') }}</b>
          </div>
        </p-card>
      }

      <!-- Relatório -->
      <p-card>
        <div class="flex flex-wrap items-center gap-2 mb-3">
          <p-selectbutton [options]="opcoesVer()" [ngModel]="verSituacao()" (ngModelChange)="verSituacao.set($event ?? 'todas')"
                          optionLabel="label" optionValue="value" size="small"/>
          <span class="ml-auto"></span>
          @if (podeEditar && bot.localizacoesPendentes().length && !bot.rodando()) {
            <p-button [label]="'Atualizar a Localização (' + bot.localizacoesPendentes().length + ')'" icon="pi pi-map-marker"
                      severity="secondary" [outlined]="true" size="small" [loading]="bot.gravandoLocalizacao()" (onClick)="gravarLocalizacoes()"
                      pTooltip="Grava na coluna Localização a(s) unidade(s) do SEI onde cada processo está (só onde é diferente)"/>
          }
          <p-button label="Baixar em Excel" icon="pi pi-file-excel" severity="secondary" [outlined]="true" size="small"
                    [disabled]="!bot.progresso().feitos && !bot.algumaCaixaLida()" (onClick)="baixar()"
                    [pTooltip]="temFiltro() ? 'Baixa só as linhas filtradas' : ''"/>
          @if (!bot.rodando()) {
            <p-button label="Limpar" icon="pi pi-trash" severity="secondary" [text]="true" size="small" (onClick)="limpar()"/>
          }
        </div>

        @if (bot.estado().atualizarLocalizacao || bot.localizacoesGravadas() || bot.erroLocalizacao()) {
          <div class="text-xs mb-2" [class.text-red-700]="bot.erroLocalizacao()">
            <i class="pi pi-map-marker mr-1"></i>
            @if (bot.erroLocalizacao()) { {{ bot.erroLocalizacao() }} }
            @else {
              Localização: {{ bot.localizacoesGravadas() }} notificação(ões) atualizada(s){{ bot.gravandoLocalizacao() ? ' (gravando…)' : '' }}.
              @if (bot.estado().atualizarLocalizacao && bot.rodando()) { Grava de 25 em 25 enquanto pesquisa. }
            }
          </div>
        }

        @if (verSituacao() === 'so-sei') {
          <ul class="text-sm text-gray-500 dark:text-gray-400 mb-2 space-y-0.5">
            @for (c of bot.estado().caixas; track c) {
              @if (bot.estado().caixasLidas[c]; as lida) {
                <li>Caixa <b>{{ c }}</b> lida em {{ lida.quando | date: 'dd/MM/yyyy HH:mm' }}: {{ lida.numeros.length }} processo(s) no SEI.</li>
              } @else if (bot.lendoCaixa() === c) {
                <li>Caixa <b>{{ c }}</b>: lendo no SEI…</li>
              } @else {
                <li>Caixa <b>{{ c }}</b>: ainda não lida.</li>
              }
            }
            <li><b>{{ bot.soNoSei().length }}</b> processo(s) nessas caixas sem notificação no SisNot.</li>
          </ul>
          <p-table [value]="bot.soNoSei()" [paginator]="true" [rows]="50" styleClass="p-datatable-sm">
            <ng-template #header>
              <tr><th>Processo SEI</th><th>Caixa</th><th></th></tr>
            </ng-template>
            <ng-template #body let-x>
              <tr>
                <td class="tabular-nums"><app-abrir-sei [texto]="x.numero"/></td>
                <td class="text-xs">{{ x.caixas.join(', ') }}</td>
                <td class="text-right">
                  <a [routerLink]="['/controle-notificacoes/nova-notificacao']" [queryParams]="{processo: x.numero}"
                     class="text-sm font-semibold underline">Cadastrar no SisNot</a>
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr><td colspan="3" class="text-center text-gray-400 py-6">
                @if (bot.lendoCaixa()) { Lendo a caixa no SEI… } @else { Todos os processos da caixa têm notificação no SisNot. }
              </td></tr>
            </ng-template>
          </p-table>
        } @else {
          <p-table [value]="linhasVisiveis()" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[50, 100, 500]"
                   styleClass="p-datatable-sm" [tableStyle]="{'min-width': '60rem'}">
            <ng-template #header>
              <tr>
                <th>Nº NOT</th>
                <th>Concessionária</th>
                <th>Status SisNot</th>
                <th>Processo SEI</th>
                <th>Situação no SEI</th>
                <th>Unidade(s) no SEI</th>
                <th>Resultado</th>
              </tr>
              <!-- filtros das colunas -->
              <tr>
                <th><input pInputText [ngModel]="fNot()" (ngModelChange)="fNot.set($event)" placeholder="Contém…" class="w-full !text-sm !py-1"/></th>
                <th><p-multiselect [options]="opcoesColunas().concessionaria" [ngModel]="fConcessionaria()" (ngModelChange)="fConcessionaria.set($event)" appendTo="body"
                                 placeholder="Todos" [maxSelectedLabels]="1" selectedItemsLabel="{0} marcados" size="small" styleClass="w-full min-w-[9rem]"/></th>
                <th><p-multiselect [options]="opcoesColunas().status" [ngModel]="fStatus()" (ngModelChange)="fStatus.set($event)" appendTo="body"
                                 placeholder="Todos" [maxSelectedLabels]="1" selectedItemsLabel="{0} marcados" size="small" styleClass="w-full min-w-[9rem]"/></th>
                <th><input pInputText [ngModel]="fProcesso()" (ngModelChange)="fProcesso.set($event)" placeholder="Contém…" class="w-full !text-sm !py-1"/></th>
                <th><p-multiselect [options]="opcoesColunas().situacao" [ngModel]="fSituacao()" (ngModelChange)="fSituacao.set($event)" appendTo="body"
                                 placeholder="Todos" [maxSelectedLabels]="1" selectedItemsLabel="{0} marcados" size="small" styleClass="w-full min-w-[9rem]"/></th>
                <th><p-multiselect [options]="opcoesColunas().unidade" [ngModel]="fUnidade()" (ngModelChange)="fUnidade.set($event)" appendTo="body"
                                 placeholder="Todos" [maxSelectedLabels]="1" selectedItemsLabel="{0} marcados" size="small" styleClass="w-full min-w-[9rem]"/></th>
                <th>
                  <div class="flex items-center gap-1">
                    <p-multiselect [options]="opcoesColunas().resultado" [ngModel]="fResultado()" (ngModelChange)="fResultado.set($event)" appendTo="body"
                                 placeholder="Todos" [maxSelectedLabels]="1" selectedItemsLabel="{0} marcados" size="small" styleClass="w-full min-w-[9rem]"/>
                    @if (temFiltro()) {
                      <p-button icon="pi pi-filter-slash" [text]="true" [rounded]="true" size="small" severity="secondary"
                                pTooltip="Limpar os filtros das colunas" (onClick)="limparFiltros()"/>
                    }
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-l>
              <tr>
                <td class="whitespace-nowrap">
                  {{ l.n.numeroNotificacao || '—' }}
                  <div class="text-xs text-gray-400">{{ l.n.dataNotificacao | date: 'dd/MM/yyyy' }}</div>
                </td>
                <td>{{ l.n.concessionaria || '—' }}</td>
                <td>{{ l.n.status || '—' }}</td>
                <td class="whitespace-nowrap tabular-nums"><app-abrir-sei [texto]="l.numero"/></td>
                <td>
                  @if (l.r) { {{ situacaoSei(l) }} }
                  @else if (bot.atual() === l.numero) { <span class="text-gray-400">pesquisando…</span> }
                  @else { <span class="text-gray-400">na fila</span> }
                </td>
                <td class="text-xs">
                  @if (l.r) {
                    <!-- só o nome da unidade; a atribuição fica na dica -->
                    @for (u of l.r.unidades; track u) {
                      <div [class.font-bold]="bot.emAlgumaCaixa(u, bot.estado().caixas)" [title]="u">{{ bot.sigla(u) || u }}</div>
                    } @empty {
                      <span class="text-gray-400">{{ l.r.erro || l.r.trecho || '—' }}</span>
                    }
                    @if (l.r.status === 'sobrestado' && l.r.unidades.length) {
                      <div class="text-amber-700 dark:text-amber-400">sobrestado nessa unidade</div>
                    }
                    @if (l.novaLocalizacao) {
                      <div class="text-gray-500 dark:text-gray-400" title="Localização no SisNot hoje">
                        <i class="pi pi-map-marker text-[10px] mr-1"></i>Localização no SisNot: {{ l.n.localizacao || '—' }}
                      </div>
                    }
                    @if (l.r.naoAberto) {
                      <div class="text-red-600 dark:text-red-400" title="Está em vermelho (não visualizado) na sua unidade: o bot não abriu o processo para não tirar o vermelho">
                        <i class="pi pi-eye-slash text-[10px] mr-1"></i>em vermelho na sua unidade: não aberto pelo bot
                      </div>
                    }
                  }
                </td>
                <td class="font-semibold whitespace-nowrap" [class]="corSituacao(l.situacao)">{{ rotuloSituacao[l.situacao] }}</td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr><td colspan="7" class="text-center text-gray-400 py-6">Nenhuma notificação nesta situação{{ temFiltro() ? ' com esses filtros' : '' }}.</td></tr>
            </ng-template>
          </p-table>
        }
      </p-card>
    }
  }
</div>
